import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Space, Button as BTN, Upload, Switch, Select, Form, Input, message } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { app } from '../../config';
import getOrgAdById from '../../hooks/getOrgAdById';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const { TextArea } = Input;
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

const EditOrgAd = () => {
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('');
  const [contentType, setContentType] = useState('');
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [largeFile, setLargeFile] = useState(false);
  let user = JSON.parse(localStorage.getItem('user'));
  let adId = JSON.parse(localStorage.getItem('orgAdId'));
  const token = getTokenfromUserObj();
  const headers = { auth: token };
  let navigate = useNavigate();
  const ad = getOrgAdById(adId);
  const orgAdObj = ad.response ? ad.response.data : null;
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  console.log(orgs);
  const beforeUpload = (file) => {
    console.log(file);
    if (file.type === 'image/jpeg' || file.type === 'image/png') setContentType('img');
    else if (file.type === 'video/x-matroska' || file.type === 'video/mp4') setContentType('video');
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    console.log('file Checked');
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
      setLargeFile(true);
      message.error('Image must smaller than 20MB!');
    }
    console.log('message');
    return isJpgOrPng && isLt2M;
  };
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      console.log('uploading data');
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      setLargeFile(false);
      info.file ? console.log(info.file.response.location) : ' ';
      info.file ? setUploadedImg(info.file.response.data.Location) : console.log('Uploaded image not saved');
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/orgad/update/${adId}`, uploadObj, { headers: { auth: token } });
      if (res.data.statusCode === 200) {
        setAddUserResp(res.data);
        setTimeout(() => {
          user.userType === 'A' ? navigate('/orgads/view') : navigate('/advertisement/view');
        }, 1000);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onFinish = (values) => {
    console.log('Success:', values);
    if (user.userType === 'A') {
      setUploadObj({
        name: values.name ? values.name : orgAdObj.name,
        organizationId: values.organizationId ? values.organizationId : orgAdObj.organizationId,
        contentType: uploadedImg ? contentType : orgAdObj.contentType,
        url: uploadedImg ? uploadedImg : orgAdObj.url,
        isActive: values.isActive === true ? 1 : 0,
        updatedByUserId: user.userId,
      });
    } else if (user.userType === 'O') {
      setUploadObj({
        name: values.name ? values.name : orgAdObj.name,
        organizationId: user.organizationId,
        url: uploadedImg ? uploadedImg : orgAdObj.url,
        isActive: values.isActive === true ? 1 : 0,
        updatedByUserId: user.userId,
      });
    }
    setShow(true);
  };

  console.log(uploadObj);
  console.log(largeFile);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const submitData = () => {
    console.log('calling');
    if (largeFile === false && Object.keys(uploadObj).length > 0) {
      console.log('uploading function ');
      uploadData(uploadObj);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  function goBack() {
    if (user.userType === 'O') navigate('/advertisement/view', { replace: true });
    else navigate('/orgads/view', { replace: true });
  }
  window.addEventListener('popstate', goBack);
  const renderList = []; //For testing purposes
  return (
    <div class='row mt-4 w-75 tbl'>
      <div class='row topbar ' style={{ height: '70px' }}>
        <div class='col-lg-4 fs-3 fw-bold'>
          {' '}
          <LeftCircleOutlined onClick={() => (user.userType === 'A' ? navigate('/orgads/view') : navigate('/advertisement/view'))} className='mt-3 ml-4 back-icon' style={{ fontSize: '38px' }} />
        </div>
        <div class='col-lg-7 fs-3 fw-bold '>
          <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update Organization Ad.')} </h2>
        </div>{' '}
      </div>
      <div class='col-lg-11 mb-5 mt-4 '>
        <div class='col-lg-9 align-self-center mt-2 mb-4'>
          {ad.response ? (
            <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['name']: orgAdObj.name,
                ['organizationId']: orgAdObj.organizationId,
                ['isActive']: orgAdObj.isActive === 1 ? true : false,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              {user.userType === 'A' ? (
                <Form.Item
                  colon={false}
                  label='Organization'
                  name='organizationId'
                  rules={[
                    {
                      required: true,
                      message: 'Select Organization',
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    placeholder='Select Organization'
                    style={{
                      width: 265,
                    }}
                  >
                    {orgs.map((orgs) => {
                      return (
                        <Option key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              ) : (
                ' '
              )}

              <Form.Item
                colon={false}
                label='Title'
                name='name'
                rules={[
                  {
                    required: true,
                    message: 'Enter Ad. Title',
                  },
                ]}
              >
                <Input placeholder='Enter Title' />
              </Form.Item>

              {/* Select box for organization */}

              {/* <Form.Item
            colon={false}
            label='Valid Till'
            name='validityDate'
            rules={[
              {
                required: true,
                message: 'Please select date!',
              },
            ]}
          >
            <DatePicker disabledDate={(current) => {
              let customDate = moment().format("MM-DD-YYYY");
              return current && current < moment(customDate, "MM-DD-YYYY");
            }}  />
          </Form.Item> */}
              <Form.Item label='Image' colon={false} name='image'>
                <Space
                  direction='vertical'
                  style={{
                    width: '100%',
                  }}
                  size='large'
                >
                  <Upload
                    listType='picture'
                    maxCount={1}
                    // name="avatar"
                    // listType="picture-card"
                    className='avatar-uploader'
                    // showUploadList={false}

                    action={`${app.URL}/upload/orgadd`}
                    // action={`${app.URL}/api/upload/orgadd`}

                    headers={headers}
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                  >
                    {orgAdObj.url ? (
                      orgAdObj.contentType === 'img' ? (
                        <img
                          src={orgAdObj.url}
                          alt='unable to load'
                          style={{
                            width: '50%',
                          }}
                        />
                      ) : orgAdObj.contentType === 'video' ? (
                        <video
                          src={orgAdObj.url}
                          style={{
                            width: '90%',
                          }}
                          controls
                        >
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        ' '
                      )
                    ) : (
                      <BTN icon={<UploadOutlined />} className={'upload-btn'} style={{ color: 'black' }}>
                        Upload
                      </BTN>
                    )}
                  </Upload>
                </Space>
              </Form.Item>

              {/* <Form.Item
            colon={false}
            label='Description'
            name='description'
            rules={[
              {
                message: 'Please input your password!',
              },
            ]}
          >
            <TextArea placeholder='Enter description' rows={4} />
          </Form.Item> */}
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>
              <Form.Item
                colon={false}
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                {addUserResp.statusCode === 200 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : addUserResp.statusCode === 400 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Failed</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.data.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to Update Advertisement?</Modal.Body>
                    <Modal.Footer>
                      <Button variant='secondary' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' htmlType='submit' onClick={submitData}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Update
                </button>
                {/* <Button type="primary" htmlType="submit">
  Submit
</Button> */}
              </Form.Item>
            </Form>
          ) : (
            ' '
          )}
        </div>
      </div>
    </div>
  );
};

export default EditOrgAd;
